export { default } from './SeoTag';
